import { PhotoAppEntity } from './photoAppEntity';
import {
  PhotoSalesEntity,
} from './photoSalesEntity';
import { ChildId } from './valueObjects/childId';
import { ExpirationDate } from './valueObjects/expirationDate';
import { ExtensionDays } from './valueObjects/extensionDays';
import { LastModifiedDatetime } from './valueObjects/lastModifiedDatetime';
import { ParentId } from './valueObjects/parentId';
import { PhotoId } from './valueObjects/photoId';
import { SalesGroupId } from './valueObjects/salesGroupId';
import { SalesGroupName } from './valueObjects/salesGroupName';

import type { PhotoSalesPropsPvt, PhotoSalesPropsPub } from './photoSalesEntity';
import type { EntityDataPubType } from '@/domain/entityBase';
import type { EntityDataPubNotNullType, EntityPubNotNullType } from '@/domain/entityPub';
import type { PhotoSalesJsonPub, PhotoSalesJsonPvt } from '@/types/domain/photo/entities/photoSalesEntity';

import { FactoryPub } from '@/domain/factoryPub';

/**
 * 写真販売ファクトリ
 */
export class PhotoSalesFactory extends FactoryPub<
  PhotoSalesEntity,
  PhotoSalesPropsPvt,
  PhotoSalesJsonPvt,
  PhotoSalesPropsPub,
  PhotoSalesJsonPub
> {
  comparePub = (
    a: EntityDataPubType<PhotoSalesJsonPvt, PhotoSalesJsonPub>,
    b: EntityDataPubType<PhotoSalesJsonPvt, PhotoSalesJsonPub>,
  ) => {
    const da = new Date(a.data.expirationDate);
    const db = new Date(b.data.expirationDate);
    return da < db ? 1 : -1;
  };

  create(
    props: PhotoSalesPropsPvt,
    propsPub: EntityPubNotNullType<PhotoSalesPropsPub>,
  ): PhotoSalesEntity {
    return new PhotoSalesEntity(props, propsPub);
  }

  createFromEntityDataPub(
    props: EntityDataPubNotNullType<PhotoSalesJsonPvt, PhotoSalesJsonPub>,
  ): PhotoSalesEntity {
    return this.create({
      salesGroupId: SalesGroupId.create(props.data.salesGroupId),
      salesGroupName: SalesGroupName.create(props.data.salesGroupName),
      expirationDate: ExpirationDate.create(new Date(props.data.expirationDate)),
      extensionDays: props.data.extensionDays
        ? ExtensionDays.create(props.data.extensionDays) : undefined,
      photos: props.data.photos.map((v) => new PhotoAppEntity({
        photoId: PhotoId.create(v.photoId),
      }, null)),
      parentId: ParentId.create(props.data.parentId),
      childId: ChildId.create(props.data.childId),
      lastModifiedDatetime: LastModifiedDatetime.create(new Date(props.data.lastModifiedDatetime)),
    }, {
      sendId: props.pub.sendId,
      replyId: props.pub.replyId,
      data: {},
    });
  }
}
